export const Arrow = () => <svg fill="none" height="24" viewBox="0 0 25 24" width="25" xmlns="http://www.w3.org/2000/svg">
  <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7487">
    <path d="m20.083 11.7256h-14.99999" stroke="#992785"/>
    <path d="m14.0337 5.701 6.05 6.024-6.05 6.025" stroke="#0d2c6c"/>
  </g>
</svg>
